import {expectEither, HttpClient, useHttpClient} from '@raison/network-facade';
import {queryOptions, skipToken, useQuery} from '@tanstack/react-query';
import {TransactionSchema} from '~/entities/transactions-history';

async function fetchTransaction(http: HttpClient, id: number, {signal}: {signal: AbortSignal}) {
    return await http(`v1/search/orders/${id}`, {signal}).then(
        ...expectEither({
            200: TransactionSchema,
        })
    );
}

export function useTransactionDetails(transactionId: number | undefined, preloaded: TransactionSchema | undefined) {
    const http = useHttpClient();
    const opt = queryOptions({
        queryKey: ['/v1/search/orders/${orderId}', transactionId],
        queryFn: skipToken,
        placeholderData: preloaded,
        gcTime: 0,
    });
    if (transactionId) {
        opt.queryFn = async ({signal, client, queryKey}) => {
            const response = await fetchTransaction(http, transactionId, {signal});
            if (response.status === 'Abort') {
                await client.cancelQueries({queryKey});
                throw response.reason;
            }
            return response.json;
        };
    }
    return useQuery(opt);
}
